import { diff } from 'json-diff-ts';

import { orderBy } from '@/globals';

export interface IIgnoreChange {
  key: string;
  values: Array<string | number | null>;
}

export function getDiff(
  original,
  updated,
  ignoreProperties = [],
  ignoreIfAdded = [],
  ignoreChanges: Array<IIgnoreChange> = [],
  ignoreIfRemoved: Array<IIgnoreChange> = [], // Ignore 'REMOVE' diffs for provided values.
) {
  let diffs = diff(original, updated).filter((x) => !ignoreProperties.includes(x.key));

  if (ignoreIfAdded.length > 0) {
    diffs = diffs.filter((x) => {
      if (x.type === 'ADD' && ignoreIfAdded.includes(x.key)) {
        return false;
      }
      return true;
    });
  }

  ignoreChanges.forEach((ignoreChange) => {
    const diffEntries = diffs.filter((x) => x.key === ignoreChange.key);
    switch (diffEntries.length) {
      case 1: {
        const [diffEntry] = diffEntries;
        if (diffEntry.type === 'UPDATE') {
          if (ignoreChange.values.includes(diffEntry.value) && ignoreChange.values.includes(diffEntry.oldValue)) {
            diffs = diffs.filter((x) => x !== diffEntry);
          }
        }
        break;
      }
      default: {
        const diffEntryAdded = diffEntries.find((x) => x.type === 'ADD');
        const diffEntryRemoved = diffEntries.find((x) => x.type === 'REMOVE');
        if (
          ignoreChange.values.includes(diffEntryAdded?.value) &&
          ignoreChange.values.includes(diffEntryRemoved?.value)
        ) {
          diffs = diffs.filter((x) => x !== diffEntryAdded && x !== diffEntryRemoved);
        }
        break;
      }
    }
  });

  ignoreIfRemoved.forEach((ignoreChange) => {
    const didFindMatch = diffs.some(
      (x) => ignoreChange.key === x.key && x.type === 'REMOVE' && ignoreChange.values.includes(x.value),
    );
    if (didFindMatch) {
      diffs = diffs.filter((x) => ignoreChange.key !== x.key);
    }
  });

  return diffs;
}

export function getArrayDiff(original, updated, ignoreProperties = []) {
  // this is done to prevent the diff function from return a diff because the list is the same, just not in the same order
  if (original.some((x) => typeof x === 'object') && updated.some((x) => typeof x === 'object')) {
    original = orderBy(original, 'id');
    updated = orderBy(updated, 'id');
  } else {
    original = original.sort();
    updated = updated.sort();
  }

  return diff(original, updated).filter((x) => !ignoreProperties.includes(x.key));
}
